import React from 'react';
import {graphql, useMutation} from 'react-relay/hooks';
import classNames from 'classnames';
import HeartIcon from '../../../../assets/icons0/heart.svg';
import {useAuthorizationState} from '../../../../contexts/Authorization';
import {getRecaptchaToken} from '../../../../utils/recaptcha';

const LikeButton = React.memo(({postId, likesCount, isLiked, isAuthorized, onShowLoginPrompt}) => {

    const [likePost, isLikingPost] = useMutation(
        graphql`
            mutation likeButtonLikeVibePostMutation($request: LikeVibePostRequestInput!) {
                likeVibePost(request: $request) {
                    id
                    likesCount
                    likedByCurrentUser
                }
            }
        `
    );

    const [unlikePost, isUnlikingPost] = useMutation(
        graphql`
            mutation likeButtonUnlikeVibePostMutation($request: LikeVibePostRequestInput!) {
                unlikeVibePost(request: $request) {
                    id
                    likesCount
                    likedByCurrentUser
                }
            }
        `
    );

    const handleLikeClick = async () => {
        if (!isAuthorized) {
            onShowLoginPrompt?.();
            return;
        }

        try {
            const reCaptcha = await getRecaptchaToken();
            if (isLiked) {
                unlikePost({
                    variables: {request: {postId: postId, reCaptcha}}
                });
            } else {
                likePost({
                    variables: {request: {postId: postId, reCaptcha}}
                });
            }
        } catch (error) {
            console.error('reCAPTCHA error:', error);
        }
    };

    return (
        <button
            onClick={handleLikeClick}
            disabled={isLikingPost || isUnlikingPost}
            className={classNames(
                'display-flex align-items-center column-gap-0dot5rem background-color-transparent border-style-none padding-0 padding-bottom-0dot25rem border-bottom-style-solid border-bottom-width-0dot125rem border-bottom-color-transparent',
                {
                    'cursor-pointer': !isLikingPost && !isUnlikingPost,
                    'opacity-0dot5 cursor-not-allowed': isLikingPost || isUnlikingPost
                }
            )}
        >
            <HeartIcon 
                className={classNames('display-block width-1dot25rem height-1dot25rem', {
                    'color-error-500': isLiked,
                    'color-gray-400': !isLiked
                })}
            />
            <span className={classNames('text-sm', {
                'color-error-400 semibold': isLiked,
                'color-gray-500': !isLiked
            })}>
                {(likesCount || 0)}{(isLikingPost || isUnlikingPost) ? '...' : ''}
            </span>
        </button>
    );
});

export default LikeButton;

